module.exports = __webpack_public_path__ + "img/n4.f391bd7b.jpg";